<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Amount">
                    <AmountSelectorSiyum/>
                </FormSection>
                <FormSection title="Sponsorship Information">
                  <FormRow inline>
                    <FormCol field="custom.shiur">
                      <FormInput type="text" />
                    </FormCol>
                  </FormRow>                
                  <FormRow inline>
                    <FormCol field="custom.specialInstructions">
                      <FormInput type="textarea" />
                    </FormCol>
                  </FormRow>
                </FormSection>                
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>                     
                    <DonorAddress />
                </FormSection>
                <FormSection title="Additional Information">
                  <FormRow inline>
                    <FormCol field="custom.dedication">
                      <FormInput type="textarea" />
                    </FormCol>
                  </FormRow>                
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import AmountSelectorSiyum from './amount-selector-siyum.vue'


export default defineComponent({
    components: {
    AmountSelectorSiyum,
  },

  setup() {
    const { form, submit } = usePaymentForm()

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
</style>

